import { useEffect, useState } from 'react';
import useUserApi, { ErrorHandler } from '../Services/UserApi';
import { EftposPosList, EftposPosListItem } from 'shared-components';

export interface EftposPosListWithItems extends EftposPosList {
	items: EftposPosListItem[];
}

export default function useEftposPosLists() {
	const [eftposPosLists, setEftposPosLists] = useState<EftposPosListWithItems[]>();

	const userApi = useUserApi();

	useEffect(() => {
		userApi<{ eftposPosLists: EftposPosListWithItems[] }>({
			route: `eftpos/api`,
			data: {
				action: 'getEftposPosLists',
			},
			errorMessage: 'Error loading eftpos pos lists',
		})
			.then((res) => {
				setEftposPosLists(res.data.eftposPosLists);
			})
			.catch((e: unknown) => ErrorHandler.toast(e));
	}, [userApi]);

	return eftposPosLists;
}
